import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022KtoDelStatus: 'idle',
    startProcess1022KtoDelError: undefined as any,
    loadUserParamsProcess1022KtoDelStatus: 'idle',
    loadUserParamsProcess1022KtoDelError: undefined as any,

    process1022KtoDelList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022KtoDel = createAsyncThunk('process1022KtoDelSlice/startProcess1022KtoDel', async ({ process1022KtoDel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022KtoDel/`,
        prepareData(process1022KtoDel),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022KtoDelStatus } = getState().process1022KtoDelSlice
        return startProcess1022KtoDelStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022KtoDel = createAsyncThunk('process1022KtoDelSlice/loadUserParamsProcess1022KtoDel', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022KtoDel/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022KtoDelStatus } = getState().process1022KtoDelSlice
        return loadUserParamsProcess1022KtoDelStatus !== 'pending'
    }
})

const Process1022KtoDelSlice = createSlice({
    name: 'process1022KtoDelSlice',
    initialState,
    reducers: {
        resetstartProcess1022KtoDel: (state) => {
            state.job = undefined
            state.startProcess1022KtoDelError = undefined
        },
        resetstartProcess1022KtoDelError: (state) => {
            state.startProcess1022KtoDelError = undefined
        },
        resetloadUserParamsProcess1022KtoDel: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022KtoDelError = undefined
        },
        resetloadUserParamsProcess1022KtoDelError: (state) => {
            state.loadUserParamsProcess1022KtoDelError = undefined
        },
        removeFromProcess1022KtoDelListById: (state, action) => {
            state.process1022KtoDelList = state.process1022KtoDelList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022KtoDelListByIds: (state, action) => {
            state.process1022KtoDelList = state.process1022KtoDelList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022KtoDelList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022KtoDelStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022KtoDelList = []
            state.startProcess1022KtoDelStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022KtoDel.pending, (state) => {
            state.startProcess1022KtoDelStatus = 'pending'
            state.startProcess1022KtoDelError = undefined
        })
        builder.addCase(startProcess1022KtoDel.fulfilled, (state, action) => {
            state.startProcess1022KtoDelStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022KtoDel.rejected, (state, action) => {
            state.startProcess1022KtoDelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022KtoDelError = action.error.message
            } else {
                state.startProcess1022KtoDelError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022KtoDel.pending, (state) => {
            state.loadUserParamsProcess1022KtoDelStatus = 'pending'
            state.loadUserParamsProcess1022KtoDelError = undefined
        })
        builder.addCase(loadUserParamsProcess1022KtoDel.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022KtoDelStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022KtoDel.rejected, (state, action) => {
            state.loadUserParamsProcess1022KtoDelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022KtoDelError = action.error.message
            } else {
                state.loadUserParamsProcess1022KtoDelError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022KtoDel,
    resetstartProcess1022KtoDelError,
    resetloadUserParamsProcess1022KtoDel,
    resetloadUserParamsProcess1022KtoDelError,
    removeFromProcess1022KtoDelListById,
    removeFromProcess1022KtoDelListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022KtoDelSlice.actions
export default Process1022KtoDelSlice.reducer
